import { render } from "./CatTabs.vue?vue&type=template&id=0217676e&scoped=true"
import script from "./CatTabs.vue?vue&type=script&lang=js"
export * from "./CatTabs.vue?vue&type=script&lang=js"

import "./CatTabs.vue?vue&type=style&index=0&id=0217676e&scoped=true&lang=css"

import exportComponent from "D:\\phpstudy_pro\\data.yuandiansiyu.com\\platform_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0217676e"]])

export default __exports__